import moment from 'moment';

export function formatData(dataSet, formatDate = true) {
  dataSet.map((data) => {
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    var countDecimals = function (value) {
      if (Math.floor(value) !== value)
        return value.toString().split('.')[1].length || 0;
      return 0;
    };
    Object.keys(data).map((key) => {
      if (isFloat(data[key])) {
        const decimals = countDecimals(data[key]);
        data[key] = data[key].toFixed(decimals);
      }
    });
    if (formatDate) {
      // data.timeStamp = moment(data.timeStamp, 'YYYY-MM-DDTHH:mm:ssZ').format(
      //   'MM/DD/YYYY HH:mm:ss',
      // );
    }
  });
  return dataSet;
}
